import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { BusinessDecisioning } from "../../src/landingPage/views/Usecases/BusinessDecisioning/BusinessDecisioning";

const BusinessDecisioningPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/business-decisoning"
        title={meta.usecases.businessdecisioning.title}
        description={meta.usecases.businessdecisioning.description}
      />
      <BusinessDecisioning />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default BusinessDecisioningPage;
